export const VOTING_YEAR = 2026

export function voteStorageKey(
  year: number | string,
  category: string
): string {
  return `vote-${year}-${category}`
}

export function hasVoted(year: number | string, category: string): boolean {
  return localStorage.getItem(voteStorageKey(year, category)) !== null
}
